import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { fmtDate, fmtINR } from "@/lib/api";
import { StatusChip } from "@/components/StatusChip";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";

export default function MyIndents() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/indents/mine").then((r) => setItems(r.data || [])).finally(() => setLoading(false)); }, []);
  return (
    <div className="space-y-6">
      <div className="flex items-end justify-between flex-wrap gap-4">
        <div>
          <h1 className="text-3xl sm:text-4xl font-bold text-[#0D3B66] tracking-tight">My Indents</h1>
          <p className="mt-1.5 text-slate-500">All indents you have raised, with current status.</p>
        </div>
        <Link to="/indents/new">
          <Button data-testid="new-indent-btn-page" className="rounded-full bg-[#F97316] hover:bg-[#EA6A0E]"><Plus className="h-4 w-4 mr-1.5" /> New Indent</Button>
        </Link>
      </div>
      {loading ? <div className="text-slate-500">Loading…</div> : items.length === 0 ? (
        <div data-testid="empty-my-indents" className="rounded-lg border border-dashed border-slate-300 p-10 text-center text-slate-500">
          No indents yet.
        </div>
      ) : (
        <div className="space-y-3">
          {items.map((i) => (
            <Card key={i.id} data-testid={`my-indent-${i.id}`} className="p-4 border-slate-200">
              <div className="flex items-start justify-between gap-4 flex-wrap">
                <div className="min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-xs font-mono bg-slate-100 rounded px-1.5 py-0.5 text-slate-700">{i.iow_code}</span>
                    <span className="text-sm font-semibold text-slate-800">{i.description}</span>
                    {i.urgency === "Urgent" && <StatusChip status="Urgent" />}
                    {i.budget_flag && <span data-testid={`budget-flag-${i.id}`} className="text-[11px] px-2 py-0.5 rounded-full bg-amber-100 text-amber-800 border border-amber-200">⚠ budget {i.cum_pct_after}%</span>}
                  </div>
                  <div className="text-xs text-slate-500 mt-1.5">Qty {i.qty} {i.uom} · {fmtDate(i.raised_at)}</div>
                  {i.remarks && <div className="text-xs text-slate-500 mt-1 italic">“{i.remarks}”</div>}
                  {i.approver_remark && <div className="text-xs text-slate-600 mt-1">Approver: <em>“{i.approver_remark}”</em></div>}
                </div>
                <div className="flex flex-col items-end gap-1.5">
                  <div className="text-sm font-semibold text-[#0D3B66]">{fmtINR(i.value)}</div>
                  <StatusChip status={i.status} />
                </div>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
